import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import TopMenuStore from '@src/business-components/top-menu/store';
import NewsStore from '@src/pages/main/components/news/store';
import FeatureStore from '@src/pages/main/components/feature/store';
import SchoolStore from '@src/pages/main/components/school/store';
import StrategyStore from '@src/pages/main/components/strategy/store';
import AuditionStore from '@src/pages/main/components/audition/store';
import OfficialCommunityStore from '@src/business-components/official-community/store';
import { computed, observable } from 'mobx';
import { useRequest } from 'ahooks';
import Toast from '@src/components/toast';
import { getParameterByNames } from '@src/utils/common-util';
import aos from '@src/utils/aos';
import { getOmniData, KvDownloadChannelId, KvIds } from '@src/services/omni-api';
import { isAndroid, isIOS, isMobile } from 'detect-mobile-device';
import useUnmount from '@src/utils/hooks/use-unmount';
import Video from '@src/components/video';
import $$tracker from '@src/tracker';
import reloadWhenPageShowByCache from '@src/utils/reload-when-page-show-by-cache';
import { aLink } from '@src/utils/common-util';
import { HIDE_DATA } from '@src/constants/urls';

class MainStore extends BaseStore {
  topMenuStore = new TopMenuStore({ isHideStrategy: () => this.hideData });
  newsStore = new NewsStore({
    redirect: path => {
      this.redirect(path);
    }
  });

  featureStore = new FeatureStore();
  schoolStore = new SchoolStore();
  strategyStore = new StrategyStore({
    redirect: path => {
      this.redirect(path);
    }
  });
  auditionStore = new AuditionStore({
    redirect: path => {
      this.redirect(path);
    }
  });
  officialCommunityStore = new OfficialCommunityStore({
    type: 'main'
  });

  @observable subscribeCount = 0;
  @observable configData = null;

  @observable game_stage_config;

  // appointment-预约 pre_download-预下载 beta_download-公测
  @observable state;

  //下载链接
  @observable downloadUrl;

  //充值链接
  @observable rechargeUrl;

  //移动端kv
  @observable kvImageMo;

  //kv相关信息
  @observable kvData;

  @observable cleanUp;

  //锚点
  @observable part;
  //隐藏攻略模块
  @observable hideData = HIDE_DATA;

  VIDEO_PLAY_CONTROL = {
    PC: 'pc',
    MO: 'mo'
  };

  @computed
  get isByAppointment() {
    return !!this.configData?.phone;
  }

  onAppointmentClick = () => {
    // console.log('------------------');
    $$tracker.clickToReserveGame(this.getCurrentState());
    this.topMenuStore.onAppointmentClick();
  };

  onAppointmentCompletedClick = () => {
    this.topMenuStore.onAppointmentCompletedClick();
  };

  getCurrentState = () => {
    if (this.game_stage_config === 'appointment') {
      return '预约期';
    } else if (this.game_stage_config === 'pre_download') {
      return '预下载期';
    } else {
      return '公测期';
    }
  };

  getCurrentSystem = () => {
    const ua = navigator.userAgent;
    // 优先判断鸿蒙（避免被安卓拦截）
    if (/HarmonyOS|HuaweiBrowser|ArkWeb/.test(ua)) {
      return '鸿蒙';
    } else if (isIOS()) {
      return '苹果';
    } else if (isAndroid()) {
      return '安卓';
    } else if (!isMobile()) {
      // 非移动设备，归为PC端
      return 'PC端';
    } else {
      // 其他未识别的系统
      return '其他';
    }
  };

  /**
   * 点击下载游戏
   */
  onDownloadClick = () => {
    $$tracker.clickToDownload(this.getCurrentSystem());

    const url = isAndroid() ? this.downloadUrl?.android : this.downloadUrl?.apple;
    if (url) {
      aLink(url);
    } else {
      Toast.info('敬请期待');
    }
  };

  /**
   * 点击官方充值
   */
  onRechargeClick = () => {
    $$tracker.clickGoRecharge();
    const url = this.downloadUrl?.charge;
    if (url) {
      aLink(url);
    } else {
      Toast.info('充值入口将于公测开启后开放，敬请期待');
    }
  };

  /**
   * 点击视频按钮
   */
  onKvVideoClick = () => {
    // if (this.kvData.kv_pv_video) {
    //   const { close } = Video.append({ src: this.kvData.kv_pv_video });
    //   this.cleanUp = close;
    // } else {
    //   Toast.info('敬请期待');
    // }
    $$tracker.clickKvVideo();
    if (this.kvData.kv_pv_video) {
      const { close } = Video.append({ src: this.kvData.kv_pv_video });
      this.cleanUp = close;
    } else {
      Toast.info('敬请期待');
    }
  };

  getConfigAsync = () => {
    return this.$ztService
      .getConfig(0)
      .then(res => {
        // console.log('getconfig:', res);
        this.configData = res;
      })
      .catch(error => {
        const { message } = error?.serviceResponse;
        Toast.fail(message);
      });
  };
  getSubscribeCountAsync = () => {
    return this.$ztService
      .getSubscribeCount()
      .then(res => {
        // console.log(res);
        this.subscribeCount = res?.subscribe_total || 0;
      })
      .catch(error => {
        const { message } = error?.serviceResponse;
        Toast.fail(message);
      });
  };

  getKVInfoAsync = () => {
    const dataSources = Object.values(KvIds).map(tab => {
      return {
        dataSourceId: tab || '',
        page: 1,
        perPage: 99
      };
    });
    return getOmniData(KvDownloadChannelId, dataSources)
      .then(res => {
        this.kvImageMo = res?.[KvIds.kv]?.result?.items[0]?.kv_image_mo[0]?.url;

        const kvData = res?.[KvIds.kv]?.result?.items?.[0] || {};
        if (kvData) {
          console.log(kvData, kvData?.play_control?.includes(this.VIDEO_PLAY_CONTROL.MO));
          this.kvData = {
            kv_image: kvData.kv_image?.[0]?.url,
            // kv_pv_video: kvData.kv_pv_video?.[0]?.url,
            kv_pv_video: kvData.homepage_kv?.[0]?.url,

            kv_video: kvData.kv_video?.[0]?.url,
            kv_play_bg_img: kvData?.play_bg_img[0]?.url,
            kv_play_conctrol: kvData?.play_control?.includes(this.VIDEO_PLAY_CONTROL.MO)
          };
        }

        // console.log(this.kvImageMo, this.kvData);

        const stage = res?.[KvIds.stage]?.result?.items?.[0];
        this.game_stage_config = stage?.game_stage_config || 'appointment';

        if (this.game_stage_config === 'appointment') {
          this.state = 3;
        } else if (this.game_stage_config === 'pre_download') {
          this.state = 2;
        } else {
          this.state = 1;
        }
        // this.state = 1;

        let downloadUrl = {};
        let download = res?.[KvIds.default_download]?.result?.items || []; // 下载数据

        download?.forEach(element => {
          downloadUrl[element.download_channel_code] = element.download_link?.url || element.channel_qrcode?.[0]?.url;
        });

        // 判断是带有渠道标识
        const utm_source = getParameterByNames('utm_source');
        const utmInfo = res?.[KvIds.custom_download]?.result?.items || [];
        if (utm_source) {
          const utmUrl = utmInfo.find(it => it.download_channel_code === 'utm_source' && it.utm_source === utm_source)?.download_link?.url;
          if (utmUrl) {
            downloadUrl.android = utmUrl;
            downloadUrl.qrcode = utmUrl;
            // downloadUrl.charge = utmUrl;
          }
        }
        // console.log(downloadUrl, download, res);
        // console.log(downloadUrl, '---------------------');

        this.downloadUrl = downloadUrl;
      })
      .catch(error => {
        // console.log(error);
        Toast.fail(error?.msg);
      });
  };

  scrollInto = id => {
    const partElement = document.getElementById(id);
    if (!partElement) {
      return;
    }

    // overflow: hidden 的 main-root 仍可被 scrollIntoView 滚动，需确保只滚动 window。
    const mainRoot = document.querySelector('.main-root');
    if (mainRoot) {
      mainRoot.scrollTop = 0;
    }

    // 偏移量与顶部导航 react-scroll 的 offset 保持一致, 保证菜单点击与带 part 参数进入时落点相同
    const anchorOffset = { news: 34, data: 120 }[id] || 0;
    const top = partElement.getBoundingClientRect().top + window.pageYOffset - anchorOffset;
    window.scrollTo({
      top,
      behavior: 'smooth'
    });
  };

  getPartId = () => {
    const { part } = this.$routeMatch.query;
    this.part = part;
    this.scrollInto(part);
  };

  use() {
    super.use();
    useMount(() => {
      reloadWhenPageShowByCache();
      aos.reInit();
      this.getPartId();
      this.topMenuStore.getConfigAsync = this.getConfigAsync;
    });
    this.getConfigRequest = useRequest(
      async () => {
        await this.getConfigAsync();
      },
      { manual: false }
    );

    useUnmount(() => {
      this.cleanUp && this.cleanUp();
    });
    this.getSubscribeCountRequest = useRequest(
      async () => {
        await this.getSubscribeCountAsync();
      },
      { manual: false }
    );
    this.getKVInfoRequest = useRequest(
      async () => {
        await this.getKVInfoAsync();
      },
      { manual: false }
    );
  }
}

export default MainStore;
